import { render, staticRenderFns } from "./TheRecipientsArea.vue?vue&type=template&id=f2c4a8ea"
import script from "./TheRecipientsArea.vue?vue&type=script&lang=js"
export * from "./TheRecipientsArea.vue?vue&type=script&lang=js"
import style0 from "./TheRecipientsArea.vue?vue&type=style&index=0&id=f2c4a8ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports